import { render, staticRenderFns } from "./WelcomePost.vue?vue&type=template&id=3f312cfb&scoped=true"
import script from "./WelcomePost.vue?vue&type=script&lang=js"
export * from "./WelcomePost.vue?vue&type=script&lang=js"
import style0 from "./WelcomePost.vue?vue&type=style&index=0&id=3f312cfb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f312cfb",
  null
  
)

export default component.exports